import React from 'react'
import { Badge, Card } from 'react-bootstrap';

const StatCard = ({title, value, percentage, isIncrease, inverse, icon: Icon}) => {
    
    // Function to determine the theme color (danger vs success)
    const getThemeColor = () => {
        if (percentage === 0) return 'secondary'; // No change 

        if (inverse) {
            // For Incidents: Up is Bad (Red), Down is Good (Green)
            return isIncrease ? 'danger' : 'success';
        }

        // For others: Up is Down (Green), Down is Bad (Red)
        return isIncrease ? 'success' : 'danger';
    };

    const theme = getThemeColor();

    return (
        <Card className={`border-0 shadow-sm h-100 border-start border-4 border-${theme}`}>
            <Card.Body>
                <div className="d-flex justify-content-between align-items-start">
                    <div>
                        <Card.Subtitle className='text-muted text-uppercase mb-2 fw-bold' style={{ fontSize: '0.75rem'}}>
                            {title}
                        </Card.Subtitle>
                        
                        <Card.Title className='fw-bold mb-0'>
                            {value.toLocaleString() || 0}
                        </Card.Title>
                    </div>
                    {/** Icon Container with subtle background */}
                    <div className={`rounded-3 bg-${theme} bg-opacity d-flex align-items-center justify-content-center`}
                        style={{ width: '48px', height: '48px'}}>
                        {Icon && <Icon size={24} className={`text=${theme}`} />}
                    </div>
                    <Badge
                        pill
                        bg={theme}
                        className={`bg-opacity-10 text-${theme} border border-${theme} border-opacity-25`}
                    >
                        {isIncrease ? '↑' : '↓'} {Math.abs(percentage)}%
                    </Badge>
                </div>
                <Card.Text className='text-muted small mt-3'>
                    <span className={`text-${theme} fw-bold`}>
                        {isIncrease ? 'Increased' : 'Decreased'}
                    </span> vs last month
                </Card.Text>
            </Card.Body>
        </Card>
    )
}

export default StatCard